// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

// import { logging } from "node_modules.bakup/@angular-devkit/core/src";

export const environment = {
  firebase: {
    projectId: 'mail-automation-b4f6d',
    appId: '1:444557042058:web:8463653b83b482cc8de873',
    storageBucket: 'mail-automation-b4f6d.appspot.com',
    apiKey: 'AIzaSyAiCG-ssUdN61VqnUAyVZxqaptOHAVisS4',
    authDomain: 'mail-automation-b4f6d.firebaseapp.com',
    messagingSenderId: '444557042058',
    measurementId: 'G-MVYKJH82GF',
  },
  stripeKey: 'pk_test_51N8oHDLVvX5SPV5iLyw6p2AThF9CMmVpTvgiDEmcFOwxyd96XJ5xtJkjfDknsbShFovJQHOYpYOHbfMEUaiMxhoJ00WAm5vHBx',
  getSecretUrl: 'https://getsecret-fqnphqcifq-ew.a.run.app',
  production: false,
  checkForUpdateInterval: 15,
  gcloudLogging: {
    projectId: 'your-project-id',
    logName: 'your-log-name',
    loggingUrl: 'your-logging-endpoint' // URL for Google Cloud Logging
    // Add any other necessary configurations for Google Cloud Logging
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
